import {useState, useRef, useEffect} from 'react'
import {useSelector} from 'react-redux';
import Spinner from '../../components/Tools/spinner';
import SubHeader from '../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import DataTable from 'react-data-table-component';
import moment from 'moment-timezone';
import { fetchUserActivities } from '../../helper/Api';


const UserLogReport = () => {
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const {financialYears} = useSelector((state) => state.authData);
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const fyList = financialYears.payload.fy_list;
    const [userActivity, setUserActivity] = useState([]);

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }

     const customStyles = {
        headCells: {
        style: {
            fontWeight: "bold",
            fontSize: "14px"
        },
        },
    };

    const columns = [
        {
        name: 'Username',
        selector: (row) => row.user_name,
        sortable: true,
        },
        {
        name: 'IP Address',
        selector: (row) => row.ip_address,
        sortable: true,
        wrap: true,
        },
        {
        name: 'Location',
        selector: (row) => row.address,
        sortable: true,
        wrap: true,
        },
        {
        name: 'User Type',
        selector: (row) => row.user_type,
        sortable: true,
        wrap: true
        },
        {
        name: 'Activity',
        selector: (row) => row.activity,
        sortable: true,
        wrap: true,
        },
        {
        name: 'Remark',
        selector: (row) => row.remark,
        sortable: true,
        wrap: true,
        },
        {
        name: 'Date & Time',
        selector: (row) => moment.utc(row.created_at).tz("Asia/Kolkata").format("DD-MM-YYYY HH:mm:ss"),
        sortable: true,
        wrap: true,
        // width:"100px"
        },
        
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1);
    };

    const fetchUserLogs = async () => {
        try {
            setLoading(true);
            const res = await fetchUserActivities();
            if(res.data.status) {
                setLoading(false);
                setUserActivity(res.data.result);
            }
        }catch(e) {
            setLoading(false);

        }
    }

    useEffect(() => {
        fetchUserLogs();
    }, [])

    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>User Activities</h4>
                    <CustomBreadcrumbs linksArray={[]} title="User Activities"/>
                </div>
                <div className="col-md-6">
                    
                </div>
            </div>
            <div className='scheme p-3'>
                <DataTable
                    customStyles={customStyles}
                    className="dataTables_wrapper"
                    columns={columns}
                    data={userActivity}
                    fixedHeader
                    fixedHeaderScrollHeight="600px"
                    pagination
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={userActivity.length}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </div>
        </div>
    )
}

export default UserLogReport
